/* eslint-disable react/require-default-props, no-unused-vars */
import PropTypes from 'prop-types'
import { createTypeElement, createPropTypes } from './util'

const Label = ({ as = 'span', size = 'large', ...props }) =>
  createTypeElement('Label', { as, size, ...props })

Label.propTypes = createPropTypes({
  size: PropTypes.oneOf(['large', 'medium', 'small', 'huge']),
})

export default Label
